if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', buildCustomSelect)
} else {
  buildCustomSelect()
}

let lastUrl = location.href
new MutationObserver(() => {
  const currentUrl = location.href
  if (currentUrl !== lastUrl) {
    lastUrl = currentUrl

    setTimeout(() => {
      buildCustomSelect()
    }, 100)
  }
}).observe(document, { subtree: true, childList: true })

function buildCustomSelect () {
  const x = document.querySelectorAll('.select.select__triangl')
  const l = x.length

  for (let i = 0; i < l; i++) {
    const selElmnt = x[i].getElementsByTagName('select')[0]
    if (!selElmnt || selElmnt.nextElementSibling) continue
    x[i].classList.add('js-custom-select-ready')
    selElmnt.setAttribute('tabindex', '-1')
    selElmnt.setAttribute('aria-hidden', 'true')
    const ll = selElmnt.length

    const listboxId = selElmnt.id ? `${selElmnt.id}-listbox` : `sort-listbox-${i}`
    const a = document.createElement('div')
    a.classList.add('select-selected')
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML
    a.setAttribute('role', 'combobox')
    a.setAttribute('tabindex', '0')
    a.setAttribute('aria-haspopup', 'listbox')
    a.setAttribute('aria-controls', listboxId)
    a.setAttribute('aria-expanded', 'false')
    x[i].appendChild(a)

    // Sync custom display when native select changes (e.g. keyboard/screen reader)
    selElmnt.addEventListener('change', () => {
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML
    })

    const b = document.createElement('div')
    b.classList.add('select-items', 'select-hide')
    b.setAttribute('id', listboxId)
    b.setAttribute('role', 'listbox')
    for (let j = 1; j < ll; j++) {
      const c = document.createElement('div')
      c.innerHTML = selElmnt.options[j].innerHTML
      c.setAttribute('role', 'option')
      c.setAttribute('tabindex', '-1')
      c.setAttribute('aria-selected', selElmnt.selectedIndex === j ? 'true' : 'false')
      c.dataset.optionIndex = String(j)
      if (selElmnt.selectedIndex === j) c.classList.add('same-as-selected')
      c.addEventListener('click', (e) => {
        const s = e.target.parentNode.parentNode.getElementsByTagName('select')[0]
        const sl = s.length
        const h = e.target.parentNode.previousSibling
        for (let idx = 0; idx < sl; idx++) {
          if (s.options[idx].innerHTML === e.target.innerHTML) {
            s.selectedIndex = idx
            h.innerHTML = e.target.innerHTML
            const y = e.target.parentNode.getElementsByClassName('same-as-selected')
            const yl = y.length
            for (let k = 0; k < yl; k++) {
              y[k].removeAttribute('class')
              y[k].setAttribute('aria-selected', 'false')
            }
            e.target.classList.add('same-as-selected')
            e.target.setAttribute('aria-selected', 'true')
            break
          }
        }
        h.dispatchEvent(new Event('input', { bubbles: true }))
      })
      b.appendChild(c)
    }
    x[i].appendChild(b)
    a.addEventListener('click', (e) => {
      e.stopPropagation()
      Array.from(document.querySelectorAll('.facets-desktop__summary')).forEach((el) => {
        el.setAttribute('aria-expanded', 'false')
      })
      Array.from(document.querySelectorAll('.facets-desktop__disclosure-vertical')).forEach((facetDetail) => {
        facetDetail.removeAttribute('open')
      })
      Array.from(document.querySelectorAll('.mobile-facets__summary')).forEach((el) => {
        el.setAttribute('aria-expanded', 'false')
        el.closest('details').removeAttribute('open')
      })
      e.target.nextSibling.classList.toggle('select-hide')
      e.target.classList.toggle('select-arrow-active')
      e.target.setAttribute('aria-expanded', e.target.nextSibling.classList.contains('select-hide') ? 'false' : 'true')
    })

    // Keyboard support
    a.addEventListener('keydown', (e) => {
      const listbox = a.nextElementSibling
      const options = listbox ? Array.from(listbox.querySelectorAll('[role="option"]')) : []
      const isOpen = !listbox.classList.contains('select-hide')

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        if (isOpen) {
          const focused = options.find((opt) => opt === document.activeElement)
          if (focused) {
            focused.click()
          }
          listbox.classList.add('select-hide')
          a.classList.remove('select-arrow-active')
          a.setAttribute('aria-expanded', 'false')
        } else {
          listbox.classList.remove('select-hide')
          a.classList.add('select-arrow-active')
          a.setAttribute('aria-expanded', 'true')
          if (options[0]) options[0].focus()
        }
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault()
        if (!isOpen) {
          listbox.classList.remove('select-hide')
          a.classList.add('select-arrow-active')
          a.setAttribute('aria-expanded', 'true')
          if (options[0]) options[0].focus()
        } else {
          const focusedIdx = options.findIndex((opt) => opt === document.activeElement)
          let next = e.key === 'ArrowDown' ? focusedIdx + 1 : focusedIdx - 1
          if (focusedIdx === -1) next = e.key === 'ArrowDown' ? 0 : options.length - 1
          next = Math.max(0, Math.min(next, options.length - 1))
          options[next].focus()
        }
      } else if (e.key === 'Escape') {
        e.preventDefault()
        listbox.classList.add('select-hide')
        a.classList.remove('select-arrow-active')
        a.setAttribute('aria-expanded', 'false')
        a.focus()
      }
    })

    b.addEventListener('keydown', (e) => {
      const listbox = e.currentTarget
      const options = Array.from(listbox.querySelectorAll('[role="option"]'))
      const trigger = listbox.previousElementSibling

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        if (e.target.getAttribute('role') === 'option') e.target.click()
        listbox.classList.add('select-hide')
        trigger.classList.remove('select-arrow-active')
        trigger.setAttribute('aria-expanded', 'false')
        trigger.focus()
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault()
        const focusedIdx = options.findIndex((opt) => opt === document.activeElement)
        let next = e.key === 'ArrowDown' ? focusedIdx + 1 : focusedIdx - 1
        next = Math.max(0, Math.min(next, options.length - 1))
        options[next].focus()
      } else if (e.key === 'Escape') {
        e.preventDefault()
        listbox.classList.add('select-hide')
        trigger.classList.remove('select-arrow-active')
        trigger.setAttribute('aria-expanded', 'false')
        trigger.focus()
      }
    })

    // Close when focus leaves the select (combobox + listbox)
    const selectWrapper = x[i]
    selectWrapper.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!selectWrapper.contains(document.activeElement)) {
          b.classList.add('select-hide')
          a.classList.remove('select-arrow-active')
          a.setAttribute('aria-expanded', 'false')
        }
      })
    })
  }
}

function closeAllSelect (elmnt) {
  const arrNo = []
  const x = document.getElementsByClassName('select-items')
  const y = document.getElementsByClassName('select-selected')
  const xl = x.length
  const yl = y.length
  for (let i = 0; i < yl; i++) {
    if (elmnt === y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove('select-arrow-active')
      y[i].setAttribute('aria-expanded', 'false')
    }
  }
  for (let i = 0; i < xl; i++) {
    if (arrNo.indexOf(i) === -1) {
      x[i].classList.add('select-hide')
    }
  }
}

document.addEventListener('click', closeAllSelect)
